import { render } from "./ActionPhoto.vue?vue&type=template&id=00f84452&scoped=true"
import script from "./ActionPhoto.vue?vue&type=script&lang=js"
export * from "./ActionPhoto.vue?vue&type=script&lang=js"

import "./ActionPhoto.vue?vue&type=style&index=0&id=00f84452&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f84452"]])

export default __exports__